import {RESET_DATA, RESET_DATA_START} from '../actionConstants';

export const resetDataStart = () => (dispatch: any) => {
  dispatch({
    type: RESET_DATA_START,
  });
};

export const resetData = () => (dispatch: any) => {
  dispatch({
    type: RESET_DATA,
  });
};
